import React from 'react';
import { CameraIcon } from 'lucide-react';
import type { BcmPhoto } from '../../data/photos';
type PhotoFrameProps = {
  photo: BcmPhoto;
  className?: string;
  /** Tailwind aspect ratio utility, e.g. "aspect-[4/5]". */
  ratio?: string;
  rotate?: string;
};

/**
 * Renders a real BCM photograph. Until the real file URL is added to
 * data/photos.ts, an honest labeled frame is shown — no stock or generated
 * people are ever substituted in.
 */
export function PhotoFrame({
  photo,
  className = '',
  ratio = 'aspect-[4/3]',
  rotate = ''
}: PhotoFrameProps) {
  return <figure className={`overflow-hidden rounded-[18px] border-2 border-brand-navy bg-brand-blue ${rotate} ${className}`} data-id="element-382" data-mp="269b2gb6qon16">
      {photo.src ? <img src={photo.src} alt={photo.alt} loading="lazy" className={`${ratio} w-full object-cover`} data-id="element-383" data-mp="2264mucxqlji1" /> : <div className={`${ratio} flex w-full flex-col items-center justify-center gap-2 px-4 py-6 text-center`} data-id="element-384" data-mp="3dne7h2slqhkx">
          <CameraIcon aria-hidden="true" className="h-6 w-6 text-brand-navy" data-id="element-385" data-mp="gsnn2u7tahrq" />
          <p className="font-display text-sm font-bold text-brand-navy sm:text-base" data-id="element-386" data-mp="lr7dp7xcohqf">
            {photo.subject}
          </p>
          <p className="font-meta text-[11px] uppercase tracking-[0.14em] text-brand-navy" data-id="element-387" data-mp="pun5nqyh5tws">
            {photo.album} · real BCM photo
          </p>
        </div>}
    </figure>;
}